import React from "react";
import { Col, Container, Row } from "react-bootstrap";
import "bootstrap/dist/css/bootstrap.min.css";
import { Helmet } from "react-helmet";
import PageSEO from "../Components/PageSEO";
import ScrollReveal from "../Components/ScrollReveal";

const schema = {
  "@context": "https://schema.org/",
  "@type": "JobPosting",
  title: "Tour Guide",
  description:
    "<p>Looking for a fun job in Cincinnati or Newport? Now hiring tour guides! Do you have a need to stand in front of strangers entertaining them with stories from our past? We're looking for enthusiastic and entertaining people who can project their voice in front of a large crowd. Must be available on weekends and weekdays if possible.</p>",
  identifier: {
    "@type": "PropertyValue",
    name: "American Legacy Tours",
    value: "2022092101",
  },
  datePosted: "2022-09-21",
  validThrough: "2026-12-31T00:00",
  employmentType: "CONTRACTOR",
  hiringOrganization: {
    "@type": "Organization",
    name: "American Legacy Tours",
    sameAs: "http://www.americanlegacytours.com",
    logo: "http://res.cloudinary.com/american-legacy-tours/image/upload/f_auto,q_auto/img/logo-color-big.png",
  },
  jobLocation: {
    "@type": "Place",
    address: {
      "@type": "PostalAddress",
      streetAddress: "1332 Vine St",
      addressLocality: "Cincinnati",
      addressRegion: "OH",
      postalCode: "45202",
      addressCountry: "US",
    },
  },
  baseSalary: {
    "@type": "MonetaryAmount",
    currency: "USD",
    value: { "@type": "QuantitativeValue", value: 12.0, unitText: "HOUR" },
  },
};

const Hiring = () => {
  return (
    <>
      <PageSEO
        title="Now Hiring | American Legacy Tours"
        description="Join the American Legacy Tours team in Cincinnati! We're hiring passionate tour guides and staff. Apply now to share Cincinnati's incredible history with our guests."
        path="/hiring"
        schema={schema}
      />

      <div
        style={{
          padding: "64px 0 80px",
          background:
            "linear-gradient(0deg, rgba(0,0,0,0.55), rgba(0,0,0,0.4)), url('https://res.cloudinary.com/american-legacy-tours/image/upload/f_auto,q_auto/img/ceilingtile.jpg') repeat",
        }}
      >
        <Container>
          <Row>
            <Col xs={12} md={8} lg={7}>
              <h2
                style={{
                  color: "#fff",
                  fontWeight: 800,
                  fontSize: "clamp(1.6rem, 4vw, 2.4rem)",
                  marginBottom: 32,
                  textShadow: "1px 2px 8px rgba(0,0,0,0.5)",
                }}
              >
                Now Hiring Tour Guides
              </h2>

              <ScrollReveal>
                <div className="glass-card">
                  <h4 style={{ fontWeight: 700, marginBottom: 12 }}>Do you love Cincinnati history?</h4>
                  <p>
                    Looking for a fun job in Cincinnati or Newport? We're now hiring tour guides!
                    Do you have a need to stand in front of strangers and entertain them with
                    stories from our past? We're looking for enthusiastic, entertaining people
                    who can project their voice in front of a large crowd.
                  </p>
                  <p>
                    Must be available on weekends and weekdays if possible. We pay{" "}
                    <strong>$12/hour plus tips</strong>.
                  </p>
                  <p style={{ marginBottom: 20 }}>
                    If interested, please email{" "}
                    <a href="mailto:craigmaness@americanlegacytours.com?subject=Tour Guide Position" style={{ fontWeight: 600 }}>
                      craigmaness@americanlegacytours.com
                    </a>{" "}
                    with your resume and use subject line{" "}
                    <strong>"Tour Guide Position"</strong>.
                  </p>
                  <a
                    href="mailto:craigmaness@americanlegacytours.com?subject=Tour Guide Position"
                    className="btn-brand"
                  >
                    Apply Now
                  </a>
                </div>
              </ScrollReveal>
            </Col>
          </Row>
        </Container>
      </div>
    </>
  );
};

export default Hiring;
